module.exports = __webpack_public_path__ + "e.no1.6636c973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/e.no1.jpg
// module id = Tj6l
// module chunks = 0